export default __webpack_public_path__ + "static/media/team66.f227b90c.JPG";